var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptionItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Composant_15_2",
    "data-name": "Composant 15 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6939",
    "data-name": "Groupe 6939",
    transform: "translate(-316.201 -30.201)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(316.201 30.201)",
    fill: "#cbc9c9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6944",
    "data-name": "Groupe 6944",
    transform: "translate(4 -24.601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6941",
    "data-name": "Groupe 6941",
    transform: "translate(0 28.601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6940",
    "data-name": "Groupe 6940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9730",
    "data-name": "Trac\\xE9 9730",
    d: "M12.011,30.481H6.627a2.586,2.586,0,0,0-4.975,0H.706a.706.706,0,1,0,0,1.411h.947a2.586,2.586,0,0,0,4.975,0h5.384a.706.706,0,1,0,0-1.411ZM4.14,32.36a1.174,1.174,0,1,1,1.174-1.174A1.175,1.175,0,0,1,4.14,32.36Z",
    transform: "translate(0 -28.601)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6943",
    "data-name": "Groupe 6943",
    transform: "translate(0 34.727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6942",
    "data-name": "Groupe 6942"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9731",
    "data-name": "Trac\\xE9 9731",
    d: "M12.011,277.106h-.949a2.586,2.586,0,0,0-4.975,0H.706a.706.706,0,0,0,0,1.411H6.088a2.586,2.586,0,0,0,4.975,0h.949a.706.706,0,0,0,0-1.411Zm-3.436,1.88a1.174,1.174,0,1,1,1.174-1.174A1.175,1.175,0,0,1,8.575,278.985Z",
    transform: "translate(0 -275.226)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionItem);
export default __webpack_public_path__ + "static/media/OptionItem.e1ff76f01ec356c86933529bc462243a.svg";
export { ForwardRef as ReactComponent };